// extracted by mini-css-extract-plugin
export default {"navbar":"Footer_navbar__eSxpM","newafooter":"Footer_newafooter__m-+Rp","activeTab":"Footer_activeTab__4yu+F","navLogo":"Footer_navLogo__kYsgT","navItem":"Footer_navItem__-3XaQ"};